<template>
    <div class="row justify-content-center mt-5">
        <div v-if="isBuilt" class="col">
            <fieldset class="bordered">
                <legend class="bordered traffic" align="center">{{title}}</legend>
                <div class="row justify-content-center my-3">
                    <div class="col">
                        <ol class="list1">
                            <li v-for="(item) in data1" v-html="item.annotation" :class="[item.category.toLowerCase()]">{{item.annotation}}</li>
                        </ol>
                    </div>
                    <div class="col">
                        <ol class="list2" start='6'>
                            <li v-for="(item) in data2" v-html="item.annotation" :class="[item.category.toLowerCase()]">{{item.annotation}}</li>
                        </ol>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</template>

<script>
    export default {
        props:['detailsCard', 'isBuilt'],
        created(){
            if(this.isBuilt){
                this.update();
                event_bus.$on('update_details', () => {
                    this.update();
                });
            }
        },
        data() {
            return {
                num_items:null,
                title:'',
                data1:[],
                data2:[]
            }
        },
        methods: {
            update(){
                this.data1 = [];
                this.data2 = [];
                this.num_items = Object.keys(this.detailsCard).length;
                let half_size1, half_size2;
                if(this.num_items == 1){
                    half_size1 = 1;
                    half_size2 = 0;
                }
                else{
                    half_size1 = Math.floor(this.num_items/2);
                    half_size2 = !!half_size1 ? this.num_items - half_size1 - 1 : 0;
                    if(!!half_size1 && (half_size1 % 2 > 0)){
                        half_size1++;
                    }
                }

                this.title = 'DAILY TRAFFIC : ACTIVITY DETAILS';

                let count = 0;
                _.each(this.detailsCard, (obj) => {
                    _.each(obj, (item) => {
                        if(count++ < half_size1){
                            this.data1.push(item);
                        }
                        else{
                            this.data2.push(item);
                        }
                    })
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '~@/_variables.scss';
    fieldset.bordered {
        border: 0.2rem groove $light-blue !important;
        border-radius:2rem;
        padding: 0 1.4em 1.4em 1.4em !important;
        margin: 0 !important;
    }

    legend.bordered {
        font-size: 1.2em !important;
        font-weight: bold !important;
        text-align: center !important;
        width:auto;
        padding:0 1rem;
        border-bottom:none;
        color:$light-blue;
    }
    ol{
        list-style: none;
        li{
            font-size:1.6rem;
            line-height:2.2rem;
        }
        &.list1{
            li{
                &.item0, &.item1, &.item2, &.item3, &.press{
                    color:$gold;
                }
                &.item4, &.ads{
                    color:$black-blue;
                }
                &.events{
                    color:$light-blue;
                }
                &.website.update{
                    color:#30902b;
                }
                &.email{
                    color:#c97f54;
                }
            }
        }
        &.list2{
            li{
                &.item0, &.item1, &.press{
                    color:$gold;
                }
                &.item2, &.ads{
                    color:$black-blue;
                }
                &.events{
                    color:$light-blue;
                }
                &.website.update{
                    color:#30902b;
                }
                &.email{
                    color:#c97f54;
                }
            }
        }
    }
</style>

